import type { BobState } from "../types";
import { planArtifacts } from "../lib/engine/artifactPlanner";
import { planToMarkdown } from "../lib/engine/exportCenter";
import { copyToClipboard } from "../lib/storage";

interface Props {
  state: BobState;
  onUpdate: (partial: Partial<BobState>) => void;
  toast: (msg: string) => void;
}

export function ArtifactPlannerPanel({ state, onUpdate, toast }: Props) {
  const latestIntake = state.intakes[state.intakes.length - 1];
  const latest = state.artifactPlans[state.artifactPlans.length - 1];

  function generate() {
    const plan = planArtifacts(latestIntake);
    onUpdate({ artifactPlans: [...state.artifactPlans, plan] });
    toast("Artifact plan generated");
  }

  async function copyPlan() {
    if (!latest) return;
    const ok = await copyToClipboard(planToMarkdown(latest));
    toast(ok ? "Plan copied" : "Copy failed");
  }

  return (
    <section className="surface glass-panel">
      <h2>Artifact Planner</h2>
      <p className="lead">
        File tree, commands, and verification list from latest intake
        {latestIntake ? `: ${latestIntake.projectName}` : " (register intake first)"}.
      </p>
      <div className="btn-row">
        <button type="button" className="btn" onClick={generate}>
          Generate artifact plan
        </button>
        <button type="button" className="btn secondary" onClick={copyPlan} disabled={!latest}>
          Copy plan markdown
        </button>
      </div>
      {latest && <pre className="output-box">{planToMarkdown(latest)}</pre>}
    </section>
  );
}
